import { render, staticRenderFns } from "./i4pro-ecm.vue?vue&type=template&id=e1ec228e&scoped=true"
import script from "./i4pro-ecm.vue?vue&type=script&lang=js"
export * from "./i4pro-ecm.vue?vue&type=script&lang=js"
import style0 from "./i4pro-ecm.vue?vue&type=style&index=0&id=e1ec228e&prod&lang=css"
import style1 from "./i4pro-ecm.vue?vue&type=style&index=1&id=e1ec228e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ec228e",
  null
  
)

export default component.exports